export const SKIP_CASHIER_AUTO_RESUME_KEY = "skipCashierAutoResume";

export function markSkipCashierAutoResume(): void {
  sessionStorage.setItem(SKIP_CASHIER_AUTO_RESUME_KEY, "1");
}

export function consumeSkipCashierAutoResume(): boolean {
  const shouldSkip = sessionStorage.getItem(SKIP_CASHIER_AUTO_RESUME_KEY) === "1";
  if (shouldSkip) {
    sessionStorage.removeItem(SKIP_CASHIER_AUTO_RESUME_KEY);
  }
  return shouldSkip;
}

export function hasSkipCashierAutoResume(): boolean {
  return sessionStorage.getItem(SKIP_CASHIER_AUTO_RESUME_KEY) === "1";
}
